import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TDropdown } from './dropdown.model';
import styles from './dropdown.module.scss';
import cx from 'classnames';
import DropdownContainer from './dropdown-container';
import DropdownToggle from './dropdown-toggle';
import DropdownItem from './dropdown-item';

const Dropdown = (props: TDropdown) => {
  const { className, children } = props;
  const [isDropdownOpen, setDropdownOpen] = useState<boolean>(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const dropdown = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (dropdown && !dropdown.current?.contains(event.target as Node)) {
      setDropdownOpen(false);
    }
  }, []);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if ((event.code === 'Escape' || event.code === 'Tab') && isDropdownOpen) {
        setDropdownOpen(false);
      }
      if ((event.code === 'Space' || event.code === 'Enter') && dropdown.current?.contains(document.activeElement) && !isDropdownOpen) {
        setDropdownOpen(true);
      }
    },
    [isDropdownOpen]
  );

  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleClickOutside, handleKeyDown]);

  const dropdownStyle = cx(styles.dropdown, className, {
    [styles.open]: isDropdownOpen,
  });

  return (
    <>
      <div className={`${dropdownStyle} dropdown-ref`} ref={dropdown} onClick={toggleDropdown}>
        {children}
      </div>
    </>
  );
};

export default Dropdown;

Dropdown.Container = DropdownContainer;
Dropdown.Toggle = DropdownToggle;
Dropdown.Item = DropdownItem;
